import { lazy } from 'react';

export const Loop = lazy(() => import('./studies/loop/loop.js'));
export const Medication = lazy(() => import('./studies/medication/medication.js'));
export const Engagement = lazy(() => import('./studies/engagement/engagement.js'));
export const Healers = lazy(() => import('./studies/healers/healers.js'));
export const AboutPageWrapper = lazy(
  () => import('../components/about-page-wrapper/about-page-wrapper.js')
);
